import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CellRenderer } from '@shared/interfaces/table/cell-renderer';
import { DATE_FORMAT } from '@app/core/constants/date-format';
import { DatePipe } from '@angular/common';
import { TooltipDirective } from '@shared/directives/tooltip/tooltip.directive';

@Component({
  selector: 'app-date-cell',
  imports: [DatePipe, TooltipDirective],
  templateUrl: './date-cell.component.html',
  styleUrl: './date-cell.component.css'
})
export class DateCellComponent extends CellRenderer implements OnInit, OnChanges {
  public dateFormat = DATE_FORMAT;

  /** Value used for rendering (keeps base `value` type intact) */
  public displayValue?: string | number | Date;

  private readonly MAX_YEAR = 3000;

  public ngOnInit(): void {
    const key = this.params?.['key'];

    if (this.params?.cellRendererParams?.format) {
      this.dateFormat = this.params.cellRendererParams.format;
    }

    const raw = this.data?.[key];
    this.displayValue = this.normalizeDate(raw);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['params']) {
      const key = this.params?.['key'];
      const raw = this.data?.[key];
      this.displayValue = this.normalizeDate(raw);
    }
  }

  private normalizeDate(raw: unknown): string | number | Date | undefined {
    if (raw === null || raw === undefined || raw === '') return undefined;

    const d = raw instanceof Date ? raw : new Date(raw as any);
    if (Number.isNaN(d.getTime())) return undefined;

    if (d.getFullYear() > this.MAX_YEAR) return undefined;

    // Return `d` (safest for DatePipe), or `raw` if you want to preserve original type
    return d;
  }
}
